import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articulo/:id" element={<ArticlePage />} />
      </Routes>
    </HashRouter>
  );
}
